import { combineReducers } from 'redux';

import settings from '../../common/reducers/settings';
import site from '../../common/state/site/reducer';
import experiments from '../../common/reducers/experiments';

export const reducer = combineReducers({
  site,
  settings,
  experiments,
});
